import { useEffect } from "react";

import Main from '../components/SpecialOffers/Main'
import HowToEarnTickets from "../components/SpecialOffers/HowToEarnTickets";
import Prizes from "../components/SpecialOffers/Prizes";
import Campaign from "../components/SpecialOffers/Campaign";

function SpecialOffers () {
 
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
      
    return(
        <div className="bg-[#1A1A28]">
            <Main/>
            <HowToEarnTickets/>
            <Prizes/>
            <Campaign/>
        </div>
    );
}

export default SpecialOffers;